<template>
  <div class="chat-widget-reference-images-picker">
    <div class="chat-widget-reference-images-picker__grid">
      <div
        v-for="(image, index) in images"
        v-show="keptIndexes.includes(index)"
        :key="index"
        class="chat-widget-reference-images-picker__item"
      >
        <img
          :src="image.value"
          :alt="image.display_name"
          class="chat-widget-reference-images-picker__img"
        >
        <button
          type="button"
          class="chat-widget-reference-images-picker__remove"
          :disabled="disabled"
          aria-label="Remove image"
          @click="remove(index)"
        >
          <i class="bi bi-x-lg" />
        </button>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-sm chat-widget-reference-images-picker__confirm"
      :class="{ 'is-pending': keptIndexes.length > 0 }"
      :disabled="disabled || keptIndexes.length === 0"
      @click="confirm"
    >
      {{ confirmLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'AIChatWidgetReferenceImagesPicker',
  props: {
    images: {
      type: Array,
      required: true,
    },
    baseProduct: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keptIndexes: this.images.map((_, i) => i),
    };
  },
  computed: {
    confirmLabel() {
      const n = this.keptIndexes.length;
      if (n === 0) return 'Remove fewer images to continue';
      if (n === 1) return 'Continue with 1 reference image';
      return `Continue with ${n} reference images`;
    },
  },
  watch: {
    images(newImages) {
      this.keptIndexes = newImages.map((_, i) => i);
    },
  },
  methods: {
    remove(index) {
      if (this.disabled) return;
      const pos = this.keptIndexes.indexOf(index);
      if (pos >= 0) {
        this.keptIndexes.splice(pos, 1);
      }
    },
    confirm() {
      if (!this.keptIndexes.length) return;
      const sortedIndexes = [...this.keptIndexes].sort((a, b) => a - b);
      const selectedUrls = sortedIndexes.map(i => this.images[i].value);
      this.$emit('action', {
        action: 'pdp_reference_images_confirm',
        payload: {
          urls: selectedUrls,
          baseProduct: this.baseProduct,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-widget-reference-images-picker {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  &__item {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    background: #fff;
  }

  &__img {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    display: block;
  }

  &__remove {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 22px;
    height: 22px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(15, 23, 42, 0.65);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    transition: background-color 0.15s;

    &:hover:not(:disabled) {
      background: rgba(15, 23, 42, 0.85);
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  &__confirm {
    width: 100%;
    padding: 10px 14px;
    border-radius: 8px;
    font-size: 13.5px;
    font-weight: 600;
    transition: box-shadow 0.15s, background-color 0.15s, border-color 0.15s;
    background-color: #f1f5f9;
    border: 1px solid #e2e8f0;
    color: #94a3b8;

    &.is-pending {
      background-color: #379C75;
      border: 1px solid #379C75;
      color: #fff;
      box-shadow: 0 0 0 3px rgba(55, 156, 117, 0.30);

      &:hover:not(:disabled) {
        background-color: #2E8D68;
        border-color: #2E8D68;
      }
    }
  }
}
</style>
